import { NgIf, NgFor, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuoteAssistService } from '../../services/quote.assist.service';
import {
  QuoteAssistModel, QuoteAssist, ToolingModel, MaterialsModel, quoteAttributesSection, ManufacturingProcessModel,
  AdditionalRequirementsModel,
  OverheadModel,
  OtherCostModel,
} from './quote-assist.model';
import { FormatDecimalDirective } from '../directives/format.decimal.directive';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Rfq, MetaDataApiResponse, RfqPart, PartQtyModel, ExtractedRfqLLM } from './rfq.model';
import { Observable, retry, catchError, finalize, timer } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { QuoteBaseComponent } from '../quote.base.component';
import { QuoteStatus, TrackingModule, TrackingEvents, MixPanelEvents } from '../shared/enums';
import { FormatNumberPipe } from '../pipes/format.number.pipe';

@Component({
  selector: 'app-quote-assist-single-api',
  imports: [NgIf, NgFor, NgClass, FormsModule, FormatDecimalDirective, FormatNumberPipe],
  templateUrl: './quote-assist.component.html',
  styleUrl: './quote-assist.component.scss'
})
export class QuoteAssistSingleApiComponent extends QuoteBaseComponent {
  queryParams = {
    rfqId: 0,
    companyId: 0,
    rfqPartId: 0,
    contactId: 0,
    integration: '',
    isTrackingEnabled:'false'
  }
  tempSummaryPartQtyModel: PartQtyModel[] = [];
  quoteGrandTotal: number = 0;
  isDataLoaded: boolean = true;
  retryCount: number = 10;
  currentPart!: RfqPart;
  currentPartQty!: PartQtyModel;
  partRangeText!: string | null;
  showHeaderLogo: boolean = true;
  profitMargin: number = 0;

  manufacturingBlankSection: ManufacturingProcessModel = this.initializeBlankManufacturingSection();
  blankToolingSection: ToolingModel = this.initializeBlankToolingSection();
  blankAMRSection: AdditionalRequirementsModel = this.initializeBlankAMRSection();
  blankOverheadSection: OverheadModel = this.initializeBlankOverheadSection();
  blankOtherSection: OtherCostModel = this.initializeBlankOtherSection();

  quoteAttributesSection: quoteAttributesSection = {
    totalCost: null as any | null,
    isVisible: false,
    isDataLoaded: false,
    isLoading: false,
    retryCount: 0,
    addNewVisible: false,
    isSectionCompleted: false,
    chatHistory: [],
    isEditable: false,
    sectionName: "",
    canCalculate: false,
    getChatHistory: () => [],
    buildChatHistory: () => { },
    clearChatHistory: () => { },
    calculateTotal: () => { }
  };

  quoteAssistModel: QuoteAssistModel = this.initializeQuoteAssistModel()

  quoteAssist: QuoteAssist = this.initializeQuoteAssist()

  rfqData: Rfq = {
    rfqId: 0,
    rfqName: '',
    companyId: 0,
    supplierId: 0,
    rfqPartList: [
      {
        rfqPartId: 0,
        partName: '',
        partDescription: '',
        process: '',
        technique: '',
        material: '',
        postProduction: '',
        tolerance: '',
        width: 0.00,
        height: 0.00,
        depth: 0.00,
        length: '',
        diameter: '',
        geometry: '',
        dimensionUnit: '',
        rfqNda: '',
        rfqLocation: '',
        qty1: 0,
        qty2: 0,
        qty3: 0,
        pdfFiles: [],
        isAssistEnabled: false,
        isAssistSkipped: false,
        isPartCompleted: false,
        quoteAssistData: this.quoteAssist,
        partQuantity: []
      }
    ],
    buyerAddress: '',
    buyerEmail: '',
    supplierMetaData: '',
    data: {},
    quoteExpiryDate: '',
    paymentTerm: '',
    quoteNumber: '',
    rfqMetaData: ''
  };

  initializeBlankManufacturingSection() {
    return {
      processName: "",
      totalLaborCost: 0.00,
      cycleTimePerUnit: null as any,
      totalLaborTimeInMinutes: null as any,
      totalMachineTimeInMinutes: 0,
      totalMachiningCost: 0.00,
      laborCostPerMinute: null as any,
      machineCostPerMinute: null as any,
      description: "",
      isEditable: false
    }
  }

  initializeBlankToolingSection() {
    return {
      toolName: "",
      estimatedCost: 0.00,
      category: "",
      purpose: "",
      isEditable: false
    }
  }

  initializeBlankAMRSection() {
    return {
      processName: "",
      estimatedCost: 0.00,
      category: "",
      purpose: "",
      isEditable: true
    }
  }

  initializeBlankOverheadSection() {
    return {
      overheadTitle: "",
      estimatedCost: 0.00,
      category: "",
      purpose: "",
      isEditable: false
    }
  }

  initializeBlankOtherSection() {
    return {
      processName: "",
      estimatedCost: 0.00,
      description: "",
      isEditable: false
    }
  }

  workflow: any = [
    {
      sectionName: "Complexity"

    },
    {
      sectionName: "Material"

    },
    { sectionName: "Tooling" },
    { sectionName: "Manufacturing" },
    { sectionName: "Machining" },
    { sectionName: "Labor" },
    { sectionName: "AMR" },
    { sectionName: "Overhead" },
    { sectionName: "OtherCosts" },
    { sectionName: "S&H" },
    { sectionName: "ProfitMargin" },
  ]

  constructor(
    private quoteAssistService: QuoteAssistService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService
  ) { super() }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['rfqId']) {
        this.queryParams.rfqId = Number(params['rfqId']);
        this.queryParams.companyId = Number(params['companyId']);
        this.queryParams.rfqPartId = Number(params['rfqPartId']);
        this.queryParams.contactId = Number(params['contactId']);
        this.queryParams.isTrackingEnabled = params['isTrackingEnabled'];
        this.queryParams.integration = params['integration'];
        this.isTrackingEnabled=this.queryParams.isTrackingEnabled ;
        this.getParamsFromParent();
      }
    });
  }

  initializeQuoteAssist() {
    return {
      assistedQty: 0,
      quoteModelLoaded: false,
      quoteAssistModel: this.quoteAssistModel
    }
  }

  initializeQuoteAssistModel() {
    return {
      complexityModel: {
        complexity: 0,
        reason: '',
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Complexity',
        getChatHistory: () => this.quoteAssistModel.complexityModel.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.complexityModel.chatHistory.push({
            Text: `Complexity: ${this.quoteAssistModel.complexityModel.complexity} - ${this.quoteAssistModel.complexityModel.reason}`,
            IsUser: false
          });
        },
        clearChatHistory: () => this.quoteAssistModel.complexityModel.chatHistory = [],
        calculateTotal: () => { }
      },
      materials: {
        materialsList: [],
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Materials',
        getChatHistory: () => this.quoteAssistModel.materials.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.materials.materialsList.forEach(material => {
            this.quoteAssistModel.materials.chatHistory.push({
              Text: `${material.name} - ${material.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.materials.chatHistory = [],
        calculateTotal: () => {
          if (this.quoteAssistModel.materials.totalCost == 0) {
            let totalCost: number = this.quoteAssistModel.materials.materialsList.reduce(
              (acc, material) => {
                material.rawMaterialPricePerPound = this.convertInternationalToDecimal(material.rawMaterialPricePerPound);
                const totalWeight = this.convertInternationalToDecimal(material.totalWeight);
                const pricePerPound = this.convertInternationalToDecimal(material.rawMaterialPricePerPound);

                if (!isNaN(totalWeight) && !isNaN(pricePerPound)) {
                  let materialTotalCost = totalWeight * pricePerPound;
                  return acc + materialTotalCost;
                }

                return acc;
              }, 0
            );
            this.quoteAssistModel.materials.totalCost = totalCost;
          }
          // this.currentPartQty.summaryData.pricePerUnit.materials.unitCost = this.quoteAssistModel.materials.totalCost / this.currentPart.quoteAssistData.assistedQty;
           this.currentPartQty.summaryData.pricePerUnit.materials.unitCost = this.convertInternationalToDecimal(this.quoteAssistModel.materials.totalCost) / (this.currentPart?.quoteAssistData?.assistedQty || 1);
           this.currentPartQty.summaryData.pricePerUnit.materials.totalCost = this.parseAndFormat(this.quoteAssistModel.materials.totalCost);
        }
      },
      tooling: {
        productName: '',
        quantityQuoted: 0,
        toolingList: [],
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Tooling',
        getChatHistory: () => this.quoteAssistModel.tooling.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.tooling.toolingList.forEach(tool => {
            this.quoteAssistModel.tooling.chatHistory.push({
              Text: `${tool.toolName} - ${tool.purpose}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.tooling.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.materials.calculateTotal();
          let i: number = 0
          this.currentPartQty.summaryData.tooling.toolingList = [];
          this.quoteAssistModel.tooling.toolingList.forEach((tool) => {
            tool.estimatedCost = this.convertInternationalToDecimal(tool.estimatedCost)
            i = i + tool.estimatedCost;
            this.currentPartQty?.summaryData.tooling.toolingList.push({
              toolName: tool.toolName,
              estimatedCost: this.convertInternationalToDecimal(tool.estimatedCost),
            });
          });
          this.quoteAssistModel.tooling.totalCost = this.parseAndFormat(i);
          this.currentPartQty.summaryData.tooling.cost = this.parseAndFormat(i);
          this.currentPartQty.summaryData.tooling.totalCost = this.parseAndFormat(i);
        }
      },
      manufacturingProcess: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        manufacturingList: [],
        canCalculate: false,
        isEditable: false,
        sectionName: 'ManufacturingProcess',
        getChatHistory: () => this.quoteAssistModel.manufacturingProcess.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(process => {
            this.quoteAssistModel.manufacturingProcess.chatHistory.push({
              Text: `${process.processName} - ${process.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.manufacturingProcess.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.tooling.calculateTotal();
          this.quoteAssistModel.manufacturingProcess.manufacturingList = this.quoteAssistModel.manufacturingProcess.manufacturingList.map(process => ({
            ...process,
            cycleTimePerUnit: this.parseAndFormat(process.cycleTimePerUnit),
            totalMachineTimeInMinutes: this.parseAndFormat(process.cycleTimePerUnit) * this.tryParseInt(this.currentPart.quoteAssistData.assistedQty)
          }));
        }
      },
      machining: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        machiningList: [],
        canCalculate: false,
        isEditable: false,
        sectionName: 'Machining',
        getChatHistory: () => this.quoteAssistModel.machining.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(machining => {
            this.multiplyMachineTimeAndCost(machining);
            this.multiplyLaborTimeAndCost(machining);
            this.quoteAssistModel.machining.chatHistory.push({
              Text: `${machining.processName} - ${machining.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.machining.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.calculateTotal();
          const totalMachiningCost = this.quoteAssistModel.manufacturingProcess.manufacturingList.reduce(
            (acc, machining) => {
              this.addSupplierMetadataForMachining(machining);
              const machineTime = this.parseAndFormat(machining.totalMachineTimeInMinutes)
              const machineCost = this.convertInternationalToDecimal(machining.machineCostPerMinute)
              return acc + machineTime * machineCost;
            }, 0
          );
          this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList = this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.map(machine => {
            const totalMachineTime = this.parseAndFormat(machine.totalMachineTimeInMinutes);
            const machineCostPerMin = this.convertInternationalToDecimal(machine.machineCostPerMinute);

            return {
              ...machine,
              cycleTimePerUnit: this.parseAndFormat(machine.cycleTimePerUnit),
              machineCostPerMinute: this.convertInternationalToDecimal(machineCostPerMin),
              totalMachiningCost: totalMachineTime * this.convertInternationalToDecimal(machineCostPerMin)
            };
          });

          this.currentPartQty.summaryData.pricePerUnit.machining.machineList = [];
          this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(process => {
            this.currentPartQty.summaryData.pricePerUnit.machining.machineList.push({
              cyclePerUnit: this.parseAndFormat(process.cycleTimePerUnit),
              costPerMin: this.convertInternationalToDecimal(process.machineCostPerMinute)
            })
          });
          this.quoteAssistModel.machining.totalCost = totalMachiningCost;
          this.currentPartQty.summaryData.pricePerUnit.machining.totalCost = totalMachiningCost;
        }
      },
      labor: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        laborList: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Labor',
        getChatHistory: () => this.quoteAssistModel.labor.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(labor => {
            this.quoteAssistModel.labor.chatHistory.push({
              Text: `${labor.processName} - ${labor.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.labor.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.machining.calculateTotal();
          let totalLaborCost: number = this.quoteAssistModel.manufacturingProcess.manufacturingList.reduce(
            (acc, labor) => {
              this.addSupplierMetadataForLabor(labor);
              return acc + this.parseAndFormat(labor.totalLaborTimeInMinutes) * this.convertInternationalToDecimal(labor.laborCostPerMinute)
            }, 0
          );
          this.quoteAssistModel.manufacturingProcess.manufacturingList = this.quoteAssistModel.manufacturingProcess.manufacturingList.map(labor => ({
            ...labor,
            totalLaborTimeInMinutes: this.parseAndFormat(labor.totalLaborTimeInMinutes),
            laborCostPerMinute: this.convertInternationalToDecimal(labor.laborCostPerMinute),
            totalLaborCost: this.parseAndFormat(labor.totalLaborTimeInMinutes) * this.convertInternationalToDecimal(labor.laborCostPerMinute)
          }));
          totalLaborCost = this.parseAndFormat(totalLaborCost);
          this.quoteAssistModel.labor.totalCost = totalLaborCost;
          this.currentPartQty.summaryData.pricePerUnit.labor.totalCost = totalLaborCost;
        }
      },
      additionalRequirements: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        additionalRequirementList: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'AMR',
        getChatHistory: () => this.quoteAssistModel.additionalRequirements.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.additionalRequirements.additionalRequirementList.forEach(requirement => {
            this.quoteAssistModel.additionalRequirements.chatHistory.push({
              Text: `${requirement.processName} - ${requirement.purpose}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.additionalRequirements.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.labor.calculateTotal();
          this.quoteAssistModel.additionalRequirements.additionalRequirementList = this.quoteAssistModel.additionalRequirements.additionalRequirementList.map(amr => ({
            ...amr,
            estimatedCost: this.convertInternationalToDecimal(amr.estimatedCost),
          }));
          let totalAdditionalRequirementsCost = this.quoteAssistModel.additionalRequirements.additionalRequirementList.reduce(
            (acc, requirement) => acc + this.parseAndFormat(requirement.estimatedCost), 0
          );
          totalAdditionalRequirementsCost = this.parseAndFormat(totalAdditionalRequirementsCost);
          this.quoteAssistModel.additionalRequirements.totalCost = totalAdditionalRequirementsCost;
          this.currentPartQty.summaryData.pricePerUnit.additionalManufacturingRequirements.totalCost = totalAdditionalRequirementsCost;
        }
      },
      overhead: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        overheadList: [],
        canCalculate: false,
        isEditable: false,
        sectionName: 'Overhead',
        getChatHistory: () => this.quoteAssistModel.overhead.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.overhead.overheadList.forEach(overhead => {
            this.quoteAssistModel.overhead.chatHistory.push({
              Text: `${overhead.overheadTitle} - ${overhead.purpose}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.overhead.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.calculateTotal();
          this.quoteAssistModel.overhead.overheadList = this.quoteAssistModel.overhead.overheadList.map(overhead => ({
            ...overhead,
            estimatedCost: this.convertInternationalToDecimal(overhead.estimatedCost),
          }));
          const totalOverheadCost = this.quoteAssistModel.overhead.overheadList.reduce(
            (acc, overhead) => acc + this.parseAndFormat(overhead.estimatedCost), 0
          );
          this.quoteAssistModel.overhead.totalCost = totalOverheadCost;
          this.currentPartQty.summaryData.pricePerUnit.overhead.totalCost = totalOverheadCost;
        }
      },
      otherCosts: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        otherCostList: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'OtherCosts',
        getChatHistory: () => this.quoteAssistModel.otherCosts.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.otherCosts.otherCostList.forEach(otherCost => {
            this.quoteAssistModel.otherCosts.chatHistory.push({
              Text: `${otherCost.processName} - ${otherCost.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.otherCosts.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.overhead.calculateTotal();
          this.quoteAssistModel.otherCosts.otherCostList = this.quoteAssistModel.otherCosts.otherCostList.map(otherCost => ({
            ...otherCost,
            estimatedCost: this.convertInternationalToDecimal(otherCost.estimatedCost),
          }));
          this.currentPartQty.summaryData.miscellaneous.itemList = [];
          const totalOtherCosts = this.quoteAssistModel.otherCosts.otherCostList.reduce(
            (acc, otherCost) => {
              this.currentPartQty.summaryData.miscellaneous.itemList.push({
                  estimatedCost: otherCost.estimatedCost,
                  itemName: otherCost.processName
              })
              return acc + this.parseAndFormat(otherCost.estimatedCost)
            }, 0
          );
          this.quoteAssistModel.otherCosts.totalCost = totalOtherCosts;
          this.currentPartQty.summaryData.miscellaneous.cost = totalOtherCosts;
        }
      },
      shipping: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        shippingCharges: 0,
        handlingCharges: 0,
        canCalculate: false,
        isEditable: false,
        sectionName: 'Shipping',
        getChatHistory: () => this.quoteAssistModel.shipping.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.shipping.chatHistory.push({
            Text: `Shipping Charges: ${this.quoteAssistModel.shipping.shippingCharges}, Handling Charges: ${this.quoteAssistModel.shipping.handlingCharges}`,
            IsUser: false
          });
        },
        clearChatHistory: () => this.quoteAssistModel.shipping.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.calculateTotal();
          this.quoteAssistModel.shipping.shippingCharges = this.convertInternationalToDecimal(this.quoteAssistModel.shipping.shippingCharges);
          this.quoteAssistModel.shipping.handlingCharges = this.convertInternationalToDecimal(this.quoteAssistModel.shipping.handlingCharges);

          const totalShippingCost = this.parseAndFormat(this.quoteAssistModel.shipping.shippingCharges) + this.parseAndFormat(this.quoteAssistModel.shipping.handlingCharges);
          this.quoteAssistModel.shipping.totalCost = totalShippingCost;
          this.currentPartQty.summaryData.shippingHandling.cost = totalShippingCost;
        }
      },
      profit: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        industryStandardProfitMargin: 0,
        description: '',
        totalPrice: 0,
        pricePerUnit: 0,
        canCalculate: false,
        isEditable: false,
        sectionName: 'Profit',
        getChatHistory: () => this.quoteAssistModel.profit.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.profit.chatHistory.push({
            Text: `Profit Margin: ${this.quoteAssistModel.profit.industryStandardProfitMargin} - ${this.quoteAssistModel.profit.description}`,
            IsUser: false
          });
        },
        clearChatHistory: () => this.quoteAssistModel.profit.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.shipping.calculateTotal();
          this.profitMargin = this.parseAndFormat(this.quoteAssistModel.profit.industryStandardProfitMargin);
          this.currentPartQty.summaryData.tooling.profitMargin = this.profitMargin;
          this.currentPartQty.summaryData.miscellaneous.profitMargin = this.profitMargin;
          this.currentPartQty.summaryData.pricePerUnit.profitMargin = this.profitMargin;
          this.currentPartQty.summaryData.shippingHandling.profitMargin = this.profitMargin;
          this.currentPart.quoteAssistData.quoteAssistModel.shipping.canCalculate = true;
          
          let total = this.calculateTotal();
          const totalCost =  total.totalCost;
          let pricePerUnit = total.pricePerUnit;
          let totalCostProfit = total.totalCostProfit;
      
          this.currentPart.quoteAssistData.quoteAssistModel.profit.pricePerUnit = pricePerUnit;
          this.currentPart.quoteAssistData.quoteAssistModel.profit.totalPrice = totalCostProfit;
          this.currentPart.quoteAssistData.quoteAssistModel.profit.totalCost = totalCost;
        }
      }
    };
  }

  private findOrCreateProcessRate(processName: string) {
      let { processRates } = this.rfqData.supplierMetaData;
      if (!processRates || !Array.isArray(processRates)) {
          console.warn("processRates is not initialized as an array. Initializing it now.");
          this.rfqData.supplierMetaData.processRates = [];
          processRates = [];
      }
      let existingProcessRate = false;
      if(processRates.length != 0){
        existingProcessRate = processRates.find((rate: any) => {
          // console.log(rate.processName);
          return rate.processName === processName;
        });
      }

    if (existingProcessRate) {
      return existingProcessRate;
    } else {
      const newProcessRate = {
        processName: processName,
        machineName: processName,
        machineRatePerHour: 0,
        labourRatePerHour: 0,
        overhead: ""
      };
      processRates.push(newProcessRate);
      return newProcessRate;
    }
  }

  addSupplierMetadataForMachining(machine: ManufacturingProcessModel) {
    if (!this.isValidString(machine?.processName)) {
      return;
    }
    const processName = machine?.processName;
    const machineCostPerMinute = this.parseAndFormat(machine?.machineCostPerMinute);

      if(this.rfqData?.supplierMetaData){
        const processRate: any = this.findOrCreateProcessRate(processName);
        processRate.machineRatePerHour = (machineCostPerMinute * 60).toFixed(2);
      }
  }

  addSupplierMetadataForLabor(labor: ManufacturingProcessModel) {
    if (!this.isValidString(labor?.processName)) {
      return;
    }
    const processName = labor?.processName;
    const laborCostPerMinute = this.parseAndFormat(labor?.laborCostPerMinute);
      if(this.rfqData?.supplierMetaData){
        const processRate: any = this.findOrCreateProcessRate(processName);
      processRate.labourRatePerHour = (laborCostPerMinute * 60).toFixed(2);
      }
  }

  updateManufacturingProcessFromSupplierMetadata(processes: ManufacturingProcessModel[]) {
    let { processRates } = this.rfqData.supplierMetaData;
    if (!processRates || !Array.isArray(processRates)) {
      console.warn("processRates is not initialized as an array. Skipping update.");
      return;
    }

    processes.forEach(process => {
      if (!this.isValidString(process?.processName)) {
        return;
      }
      const processName = process?.processName;
      const matchingProcessRate = processRates.find(rate => rate.processName === processName);

      if (matchingProcessRate) {
        const machineRatePerHour = this.parseAndFormat(matchingProcessRate.machineRatePerHour);
        const laborRatePerHour = this.parseAndFormat(matchingProcessRate.labourRatePerHour);

        process.machineCostPerMinute = machineRatePerHour / 60;
        process.laborCostPerMinute = laborRatePerHour / 60;

        console.log(`Updated ManufacturingProcessModel for process: ${processName}`);
      } else {
        console.warn(`No matching process found in supplierMetadata for process: ${processName}`);
      }
    });
  }

  generateDefaults<T>(defaultData: T, indexedDBData: Partial<T>): T {
    const result = _.cloneDeep(defaultData);

    let mergeDefaults = (defaultObj: any, indexedDBObj: any) => {
      for (const key in indexedDBData) {
        if (indexedDBObj.hasOwnProperty(key)) {
          if (
            typeof defaultObj[key] === 'object' &&
            !Array.isArray(defaultObj[key]) &&
            defaultObj[key] !== null
          ) {
            mergeDefaults(defaultObj[key], indexedDBObj[key]);
          } else if (
            Array.isArray(defaultObj[key]) &&
            Array.isArray(indexedDBObj[key])
          ) {
            const defaultArray = defaultObj[key];
            const indexedDBArray = indexedDBObj[key];

            while (indexedDBArray.length > defaultArray.length) {
              defaultArray.push(_.cloneDeep(defaultArray[0]));
            }

            for (let i = 0; i < indexedDBArray.length; i++) {
              if (typeof defaultArray[i] === 'object') {
                mergeDefaults(defaultArray[i], indexedDBArray[i]);
              }
            }
          }
        } else {
          indexedDBObj[key] = _.cloneDeep(defaultObj[key]);
        }
      }
    }

    mergeDefaults(result, indexedDBData);

    return result;
  }

  fetchMetaDataFromAPI() {
    this.showPageDataLoading = true;
    try {
      this.quoteAssistService.getMetadata(this.rfqData.rfqId, this.rfqData.companyId).subscribe({
        next: (apiResponse: MetaDataApiResponse) => {
          try {
            this.rfqData = this.parseApiResponse(apiResponse);
            this.getPartForSuggestion();
            this.quoteAssistService.setMetadata(this.getAllExtractedContent());
            this.resetAllSections();
            this.getDataFromLLM();
          } catch (error) {
            this.handleRfqFetchError(error);
          }
        },
        error: (error) => {
          this.handleRfqFetchError(error);
        },
        complete: () => {
          console.log('Metadata fetching completed.');
        }
      });
    } catch (error) {
      this.handleRfqFetchError(error);
    }
  }

  private handleRfqFetchError(error: any) {
    this.showPageDataLoading = false;
    this.toastrService.error('Failed to fetch data for the RFQ.');
    console.error('Error during metadata fetching:', error);
  }

  getPartForSuggestion() {
    let isPartSelected = false;
    let totalPartCount = this.rfqData.rfqPartList.length;
    let partNoUsed = 1;

    for (const part of this.rfqData.rfqPartList) {
      if (!part.isPartCompleted && !part.isAssistSkipped) {
        isPartSelected = true;
        this.currentPart = part;
        this.getQtyForSuggestion(part);
        break;
      }
      if(part.isAssistSkipped && !part.isPartCompleted){
        this.currentPart = part;
        this.skipQuoteAssist();
        break;
      }
      partNoUsed++;
    }
    if (!isPartSelected) {
      for (const part of this.rfqData.rfqPartList) {
        isPartSelected = true;
        this.currentPart = part;
        break;
      }
      if (this.currentPart.isAssistSkipped) {
        this.skipQuoteAssist();
      }else{
        this.proceedToQuote();
      }
      
    }
    this.tempSummaryPartQtyModel = _.cloneDeep(this.currentPart.partQuantity);
    this.addTracking(this.quoteAssistService, TrackingModule.QuoteAssist, TrackingEvents.AssistStarted, this.currentPart, this.rfqData, 
      MixPanelEvents.AssistStarted, this.queryParams);
    this.partRangeText = partNoUsed + ' of ' + totalPartCount;
  }

  getQtyForSuggestion(part: RfqPart) {
    if (!part.partQuantity || part.partQuantity.length === 0) {

      this.initializeSummary(part);
      if (part.partQuantity.length === 0) {
        throw new Error("No valid quantities found for the current part.");
      }
    }
    //uncomment below to use the lowest quantity
    //this.currentPartQty = part.partQuantity.reduce((min, current) => current.qty < min.qty ? current : min);
    this.currentPartQty = part.partQuantity[0];
    this.currentPartQty.isAssisted = true;
    this.currentPart.quoteAssistData.assistedQty = this.currentPartQty.qty;
  }

  initializeSummary(part: RfqPart) {
    const quantities = [part.qty1, part.qty2, part.qty3];
      part.partQuantity = [];
      quantities.forEach((qty, index) => {
        if (qty && qty > 0) {
          part.partQuantity.push({
            order: index + 1,
            qty: qty,
            qtyCompleted: false,
            isAssisted: false,
            summaryData: {
              isCopied: false,
              isCompleted: false,
              isDataLoaded: false,
              tooling: { totalCost: 0, cost:0, toolingList: [], profitMargin: 0, profitValue: 0 },
              pricePerUnit: {
                materials: { totalCost: 0, unitCost: 0 },
                machining: { totalCost: 0, machineList: [{ cyclePerUnit: 0, costPerMin: 0}] },
                labor: { totalCost: 0 },
                additionalManufacturingRequirements: { totalCost: 0 },
                overhead: { totalCost: 0 },
                totalPrice: 0,
                profitMargin: 0,
                profitValue: 0,
              },
              miscellaneous: { cost: 0, totalCost: 0, itemList: [], profitMargin: 0, profitValue: 0},
              shippingHandling: { cost: 0, totalCost: 0, profitMargin: 0, profitValue: 0},
              leadTime: ""
            }
          });
        }
      });
  }

  toCamelCase(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.toCamelCase(item));
    } else if (obj && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
        acc[camelKey] = this.toCamelCase(obj[key]);
        return acc;
      }, {} as any);
    }
    return obj;
  }

  parseApiResponse(response: MetaDataApiResponse): Rfq {
    try {
      let parsedMetaData = {};
      try {
        parsedMetaData = JSON.parse(response.data.rfqMetaData);
      } catch (error) {
        this.handleRfqFetchError("Error during the parsing of RFQ.");
      }

      if (!parsedMetaData || Object.keys(parsedMetaData).length === 0) {
        this.handleRfqFetchError("No data keys could be found after the parsing of RFQ.");
      }

      const parseList = this.toCamelCase(parsedMetaData) as Partial<RfqPart[]>;
      const rfqPartList: RfqPart[] = parseList.map(obj => ({ ...this.rfqData.rfqPartList[0], ...obj }));

      rfqPartList.forEach(part => {
        part.quoteAssistData = _.cloneDeep(this.initializeQuoteAssist());
        part.quoteAssistData.quoteAssistModel = _.cloneDeep(this.quoteAssistModel);
      });

      let parsedSupplierMetaData = {};
      try {
        parsedSupplierMetaData = JSON.parse(response.data.supplierMetaData);
      } catch (error) {
        console.error('Error parsing supplier metadata:', error);
      }

      let formattedSupplierMetaData = {};
      if (!parsedSupplierMetaData || Object.keys(parsedSupplierMetaData).length === 0) {
        console.warn("Supplier metadata is empty, null, or undefined. Setting to empty object.");
      } else {
        formattedSupplierMetaData = this.toCamelCase(parsedSupplierMetaData);
      }

      let parsedRFQMetaData = {};
      try {
        parsedRFQMetaData = JSON.parse(response.data.rfqMetaData);
      } catch (error) {
        console.error('Error parsing supplier metadata:', error);
      }

      let formattedRFQMetaData = {};
      if (!parsedRFQMetaData || Object.keys(parsedRFQMetaData).length === 0) {
        console.warn("RFQ metadata is empty, null, or undefined. Setting to empty object.");
      } else {
        formattedRFQMetaData = this.toCamelCase(parsedRFQMetaData);
      }

      return {
        ...this.rfqData,
        rfqId: response.data.rfqId,
        rfqName: response.data.rfqName,
        buyerAddress: response.data.buyerAddress,
        rfqPartList: rfqPartList,
        supplierMetaData: formattedSupplierMetaData,
        companyId: response.data.companyId,
        buyerEmail: '',
        rfqMetaData: formattedRFQMetaData,
        data: {}
      };
    } catch (error) {
      // Handle any unexpected errors during parsing
      console.error('Unexpected error while parsing API response:', error);
      this.toastrService.error("An unexpected error occurred while processing the RFQ data.");
      throw error; // Re-throw the error if further handling is required upstream
    }
  }

  copyRfqPartToExtractedRfqLLM(rfqPart: RfqPart): ExtractedRfqLLM {
    const extractedRFQLLM: ExtractedRfqLLM = {
        partName: rfqPart.partName,
        partDescription: rfqPart.partDescription,
        process: rfqPart.process,
        technique: rfqPart.technique,
        material: rfqPart.material,
        postProduction: rfqPart.postProduction,
        tolerance: rfqPart.tolerance,
        width: rfqPart.width,
        height: rfqPart.height,
        depth: rfqPart.depth,
        length: rfqPart.length,
        diameter: rfqPart.diameter,
        dimensionUnit: rfqPart.dimensionUnit,
        geometry: rfqPart.geometry,
        qty1: rfqPart.quoteAssistData.assistedQty,
        rfqNda: rfqPart.rfqNda,
        rfqLocation: rfqPart.rfqLocation,
    };

    return extractedRFQLLM;
}

  getAllExtractedContent(): string {
    let extractedContents: string = '';
    if (this.currentPart) {
      if(this.currentPart.pdfFiles){
        for (const file of this.currentPart.pdfFiles) {
          if (this.isValidString(file.extractedContent)) {
            extractedContents += `PDF File: ${file.extractedContent}\n`;
          }else{
            extractedContents += `PDF File: ${JSON.stringify(this.copyRfqPartToExtractedRfqLLM(this.currentPart))}`
          }
        }
      }else{
        extractedContents += `PDF File: ${JSON.stringify(this.copyRfqPartToExtractedRfqLLM(this.currentPart))}`
      }
      if (this.rfqData.supplierMetaData) {
        const { processRates, ...supplierMetaDataWithoutProcessRates } = this.rfqData.supplierMetaData as {
          processRates: Array<{
            processName: string;
            machineName: string;
            machineRatePerHour: string;
            labourRatePerHour: string;
            overhead: string;
          }>;
          employeeSize: string;
          myCapabilities: any[];
          myEquipment: any[];
          industryServing: any[];
          myAddress: string;
          zipCode: string;
          additionalInfo: Array<{
            laborRatePerHour: string;
            machineRatePerHour: any;
            pricePerUnitPerCubicInch: any;
            qty_0: string;
            qty_1: string;
            qty_2: string;
          }>;
        };
        extractedContents += `Supplier Information: ${JSON.stringify(supplierMetaDataWithoutProcessRates)}\n`;
      }
      if (this.rfqData.rfqMetaData) {
        const matchingPart = this.rfqData.rfqMetaData.find((part: any) => 
          part.rfqPartId === this.queryParams['rfqPartId']
        );
        
        if (matchingPart) {
          extractedContents += `RFQ Information: ${JSON.stringify(matchingPart)}\n`;
        }
      }
      if (this.currentPart.quoteAssistData) {
        extractedContents += `Quantity to be considered for the Quote Estimation: ${this.currentPart.quoteAssistData.assistedQty}\n`;
      }
    }
    return extractedContents.toString();
  }

  getParamsFromParent() {
    this.route.queryParams.subscribe(params => {
      this.rfqData.rfqId = params['rfqId'];
      this.rfqData.companyId = params['companyId'];
      this.rfqData.supplierId = params['contactId'];

      if (params['showHeader'] == 0) {
        this.showHeaderLogo = false;
      }
      this.loadDataSequentially();
    });
  }

  calculateMachineTime(manufacturingItem: ManufacturingProcessModel) {
    if (!this.isNullOrBlankOrEmpty(manufacturingItem.cycleTimePerUnit)) {
      manufacturingItem.totalMachineTimeInMinutes = this.convertInternationalToDecimal(manufacturingItem.cycleTimePerUnit) * this.convertInternationalToDecimal(this.currentPart.quoteAssistData.assistedQty)
    }
  }

  loadDataSequentially() {
    //this.pushTrackingDataToMFG("supplier quote assist open");
    let rfqId = parseInt(this.rfqData.rfqId.toString());
    let contactId = parseInt(this.rfqData.companyId.toString());
    this.showPageDataLoading = true;
    this.quoteAssistService.getSavedDataFromIndexedDB(rfqId).subscribe({
      next: (indexedDBData: Rfq | null) => {
        if (indexedDBData) {
          // console.log("✅ Data found in browser instance");
          let showLoader = this.processFetchedData(indexedDBData);
          this.showPageDataLoading = showLoader;
          //this.toastrService.success("Your data has been successfully loaded.");
        } else {
          // console.log("❌ No data found in IndexedDB, checking DynamoDB...");
          //this.toastrService.info("Checking for saved data in the cloud...");
          this.fetchDraftDataFromApi(contactId, rfqId)
        }
      },
      error: (error) => {
        console.error("⚠️ Error fetching from local browser instance:", error);
        //this.toastrService.warning("We encountered an issue while retrieving your data locally. Checking the cloud...");
        this.fetchDraftDataFromApi(contactId, rfqId);
      },
    });
  }

  fetchDraftDataFromApi(contactId: any, rfqId: any) {
    this.quoteAssistService.fetchDraft(contactId, rfqId).subscribe({
      next: (dynamoDBData: Rfq | null) => {
        if (dynamoDBData && dynamoDBData.data != null) {
          // console.log("✅ Data found in cloud.");
          let parsedDraft = JSON.parse(dynamoDBData.data.rfqPartsMetaData);
          let showLoader = this.processFetchedData(parsedDraft, true);
          this.saveData().subscribe(
            id => {
              // console.log("Data saved for rfq " + id);
              //this.toastrService.success("Your data has been successfully loaded and saved locally.");
            },
            saveError => {
              // console.error("⚠️ Error saving data on local browser instance.:", saveError);
              //this.toastrService.warning("We encountered an issue while saving your data locally. Please try again later.");
            }
          );
          this.showPageDataLoading = showLoader;
        } else {
          // console.log("❌ No data found in cloud, fetching from API...");
          //this.toastrService.info("No saved data found. Fetching fresh data...");
          this.fetchMetaDataFromAPI();
        }
      },
      error: (error) => {
        // console.error("⚠️ Error fetching from cloud:", error);
        //this.toastrService.warning("We encountered an issue while retrieving your data from the cloud. Attempting to fetch fresh data...");
        this.fetchMetaDataFromAPI();
      },
    });
  }

  processFetchedData(data: Rfq, fromDynamoDB: boolean = false) {
    this.rfqData = this.generateDefaults(this.rfqData, data);
    this.rfqData = _.merge(this.rfqData, data);

    this.getPartForSuggestion();
    
    if (this.currentPart.quoteAssistData.quoteModelLoaded) {
      this.quoteAssistModel = this.currentPart.quoteAssistData.quoteAssistModel;
      this.profitMargin = this.parseAndFormat(this.quoteAssistModel.profit.industryStandardProfitMargin);
      this.calculateAllSections();
      this.updateGrandTotal();
      return false;
    } else {
      if (!this.rfqData.rfqPartList.some((part) => part.isPartCompleted === true)) {
        this.fetchMetaDataFromAPI();
        return true;
      } else {
        this.quoteAssistService.setMetadata(this.getAllExtractedContent());
        this.getDataFromLLM();
        return true;
      }
    }
  }

  hideAllSections() {
    Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
      (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isVisible = false;
    });
    this.quoteAssistModel = this.currentPart.quoteAssistData.quoteAssistModel;
  }

  calculateAllSections() {
    Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
      if (prop != 'complexityModel') {
        (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].calculateTotal();
      }
    });
  }

  resetAllSections() {
    Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
      if (prop != 'materials') {
        (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isLoading = false;
        (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isVisible = false;
      }
    });
  }

  getDataFromLLM() {
    this.showPageDataLoading = true;
    const retryCount = 5;
    const retryDelayMs = 2000;
    this.quoteAssistService.getAllDataFromLLM().pipe(
      retry({
        count: retryCount,
        delay: (error, retryAttempt) => {
          this.toastrService.warning(`Retrying (${retryAttempt + 1}/${retryCount})...`, 'Fetching Data for RFQ.');
          return timer(retryDelayMs);
        }
      }),
      catchError(error => {
        this.toastrService.error('Failed to fetch data RFQ after multiple attempts.', 'Error');
        // console.error('Error fetching data from RFQ after 5 retries:', error);
        return [];
      }),
      finalize(() => {
        this.showPageDataLoading = false;
      })
    ).subscribe({
      next: (response: QuoteAssistModel) => {
        this.loadData(response);
      },
      complete: () => {
        Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
          (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isDataLoaded = true;
          (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].buildChatHistory();
        });

        this.currentPart.quoteAssistData.quoteModelLoaded = true;
        this.currentPart.quoteAssistData.quoteAssistModel.materials.calculateTotal();
        this.showSection(this.currentPart.quoteAssistData.quoteAssistModel.materials);

        this.saveData().subscribe(id => {
          // console.log("Data saved for RFQ " + id);
        });
      }
    });
  }

  loadData(response: QuoteAssistModel) {
    this.currentPart.quoteAssistData.quoteAssistModel = _.merge(this.currentPart.quoteAssistData.quoteAssistModel, response);
    this.quoteAssistModel = this.currentPart.quoteAssistData.quoteAssistModel;
    this.loadDataAndSyncWithSupplierMetadata(this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList);
  }

  loadDataAndSyncWithSupplierMetadata(manufacturingProcesses: ManufacturingProcessModel[]) {
    if (!Array.isArray(manufacturingProcesses)) {
      console.warn("Manufacturing processes are not initialized as an array. Skipping update.");
      return;
    }
    if(this.rfqData?.supplierMetaData){
      this.updateManufacturingProcessFromSupplierMetadata(manufacturingProcesses);
    }
    console.log("Data loaded and synchronized with supplier metadata.");
  }

  showSection(quoteAttributes: quoteAttributesSection, fromUI: boolean = false) {
    if (fromUI && !quoteAttributes.isSectionCompleted) {
      return;
    }
    this.hideAllSections();
    quoteAttributes.isVisible = true;
    if (!quoteAttributes.isDataLoaded) {
      if (!quoteAttributes.isLoading) {
        quoteAttributes.isLoading = true;
        // quoteAttributes.loadData();
      }
      this.toggleLoader();
    } else {
      quoteAttributes.isLoading = false;
      this.quoteAttributesSection = quoteAttributes;
      this.toggleLoader();
    }
  }

  continueClicked(event: Event, nextSection: quoteAttributesSection, currentSection: quoteAttributesSection) {
    if (this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.addNewVisible) {
      if (!this.saveNewManufacturingProcess()) {
        event.stopPropagation();
        return;
      }
    }
    if (this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.addNewVisible) {
      if (!this.saveNewAMR()) {
        event.stopPropagation();
        return;
      }
    }
    if (this.currentPart.quoteAssistData.quoteAssistModel.overhead.addNewVisible) {
      if (!this.saveNewOverhead()) {
        event.stopPropagation();
        return;
      }
    }
    if (this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.addNewVisible) {
      if (!this.saveNewOtherCost()) {
        event.stopPropagation();
        return;
      }
    }
    if(currentSection.sectionName == 'Machining' || currentSection.sectionName == 'Labor'){
      this.updateSupplierMetadata();
    }
    const eventNameKey = Object.keys(TrackingEvents).find(
      (key) => key.toLowerCase() === currentSection.sectionName.toLowerCase()
    );
    const eventNameValue = eventNameKey ? TrackingEvents[eventNameKey as keyof typeof TrackingEvents] : undefined;
    this.addTracking(this.quoteAssistService, TrackingModule.QuoteAssist, eventNameValue!.toString(), this.currentPart, this.rfqData, 
      MixPanelEvents.ProceedSummary, this.queryParams);

    event.stopPropagation();
    nextSection.calculateTotal();
    currentSection.canCalculate = true;
    currentSection.isSectionCompleted = true;
    this.updateGrandTotal();
    this.showSection(nextSection);

    this.saveData().subscribe(id => {
      // console.log("Data saved for RFQ " + id);
    });

  }

  toggleLoader() {
    this.isDataLoaded = true;
    Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
      if ((this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isLoading == true) {
        this.isDataLoaded = false;
        (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isDataLoaded = false;
      }
    });
  }

  toggleAddNewTemplate(selectedItem: quoteAttributesSection) {
    selectedItem.addNewVisible = !selectedItem.addNewVisible;
  }

  editItem(selectedItem: any) {
    selectedItem.isEditable = !selectedItem.isEditable;
  }

  saveNewToolingItem() {
    if (!this.isValidString(this.blankToolingSection.toolName)) {
      const newToolingItem: ToolingModel = {
        toolName: this.blankToolingSection.toolName,
        estimatedCost: Number(this.convertInternationalToDecimal(this.blankToolingSection.estimatedCost)),
        category: 'Primary',
        purpose: '',
        isEditable: false
      };
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.tooling);
      this.currentPart.quoteAssistData.quoteAssistModel.tooling.toolingList.push(newToolingItem);
      this.initializeBlankToolingSection();
    }
  }

  removeToolingItem(toolingItem: ToolingModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.tooling.toolingList.indexOf(toolingItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.tooling.toolingList.splice(index, 1);
    }
  }

  saveNewMaterialItem(materialCostTextbox: HTMLInputElement, toolNameTextbox: HTMLInputElement) {
    if (!this.isValidString(toolNameTextbox.value)) {
      const newMaterialItem: MaterialsModel = {
        name: toolNameTextbox.value,
        weightPerPart: 0,
        totalWeight: 0,
        rawMaterialPricePerPound: 0,
        totalMaterialCost: Number(this.convertInternationalToDecimal(materialCostTextbox.value)),
        description: 'Primary',
        isEditable: false
      };
      toolNameTextbox.value = '';
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.materials);
      this.currentPart.quoteAssistData.quoteAssistModel.materials.materialsList.push(newMaterialItem);
    }
  }

  removeMaterialItem(materialItem: any) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.materials.materialsList.indexOf(materialItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.materials.materialsList.splice(index, 1);
    }
  }

  saveNewManufacturingProcess(): boolean {
    if (this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.addNewVisible) {
      if (!this.isValidString(this.manufacturingBlankSection.processName)) {
        this.toastrService.error("Please provide the Process Name");
        return false;
      }
      var cycleTimePerUnit = this.tryParseInt(this.manufacturingBlankSection.cycleTimePerUnit);
      var totalLaborTimeInMinutes = this.tryParseInt(this.manufacturingBlankSection.totalLaborTimeInMinutes);

      if (cycleTimePerUnit == 0) {
        this.toastrService.error("Please provide valid Cycle Time");
        return false;
      }
      this.manufacturingBlankSection.cycleTimePerUnit = cycleTimePerUnit;
      this.manufacturingBlankSection.totalLaborTimeInMinutes = totalLaborTimeInMinutes;

      if (this.isValidString(this.manufacturingBlankSection.processName)
        && this.parseAndFormat(this.manufacturingBlankSection.totalMachineTimeInMinutes) > 0) {
        const newManufacturingItem: ManufacturingProcessModel = {
          processName: this.manufacturingBlankSection.processName,
          description: '',
          cycleTimePerUnit: this.manufacturingBlankSection.cycleTimePerUnit,
          totalMachineTimeInMinutes: this.manufacturingBlankSection.totalMachineTimeInMinutes,
          machineCostPerMinute: null as any,
          totalMachiningCost: 0,
          totalLaborTimeInMinutes: this.manufacturingBlankSection.totalLaborTimeInMinutes,
          laborCostPerMinute: null as any,
          totalLaborCost: 0,
          isEditable: false
        };
        this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess);
        this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.push(newManufacturingItem);
        this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.calculateTotal();
        this.manufacturingBlankSection = this.initializeBlankManufacturingSection();
      }
      return true;
    }
    return true;
  }

  //Below remove function works for Manufacturing Process, Machining and Labor
  removeManufacturingItem(manufacturingItem: ManufacturingProcessModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.indexOf(manufacturingItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.splice(index, 1);
      this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.calculateTotal();
    }
  }

  saveNewAMR() {
    if (!this.isValidString(this.blankAMRSection.processName)) {
      this.toastrService.error("Please provide the Process Name");
      return false
    }

    if (this.parseAndFormat(this.blankAMRSection.estimatedCost) == 0) {
      this.toastrService.error("Please provide the valid cost");
      return false;
    }
    if (this.isValidString(this.blankAMRSection.processName)) {
      const newAMRSection: AdditionalRequirementsModel = {
        processName: this.blankAMRSection.processName,
        estimatedCost: Number(this.convertInternationalToDecimal(this.blankAMRSection.estimatedCost)),
        category: 'Primary',
        purpose: '',
        isEditable: false
      };
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements);
      this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.additionalRequirementList.push(newAMRSection);
      this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.calculateTotal();
      this.blankAMRSection = this.initializeBlankAMRSection();
    }
    return true;
  }

  removeAMRItem(additionalItem: AdditionalRequirementsModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.additionalRequirementList.indexOf(additionalItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.additionalRequirementList.splice(index, 1);
      this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.calculateTotal();
    }
  }

  saveNewOverhead() {
    if (!this.isValidString(this.blankOverheadSection.overheadTitle)) {
      this.toastrService.error("Please provide the Overhead Title value");
      return false;
    }
    if (this.parseAndFormat(this.blankOverheadSection.estimatedCost) == 0) {
      this.toastrService.error("Please provide the Overhead Cost value");
      return false;
    }
    if (this.isValidString(this.blankOverheadSection.overheadTitle)) {
      const newOverheadSection: OverheadModel = {
        overheadTitle: this.blankOverheadSection.overheadTitle,
        estimatedCost: Number(this.convertInternationalToDecimal(this.blankOverheadSection.estimatedCost)),
        category: 'Primary',
        purpose: '',
        isEditable: false
      };
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.overhead);
      this.currentPart.quoteAssistData.quoteAssistModel.overhead.overheadList.push(newOverheadSection);
      this.currentPart.quoteAssistData.quoteAssistModel.overhead.calculateTotal();
      this.blankOverheadSection = this.initializeBlankOverheadSection();
    }
    return false;
  }
  removeOverheadItem(overheadItem: OverheadModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.overhead.overheadList.indexOf(overheadItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.overhead.overheadList.splice(index, 1);
      this.currentPart.quoteAssistData.quoteAssistModel.overhead.calculateTotal();
    }
  }

  saveNewOtherCost() {
    if (!this.isValidString(this.blankOtherSection.processName)) {
      this.toastrService.error("Please provide the Process Name");
      return false;
    }
    if (this.parseAndFormat(this.blankOtherSection.estimatedCost) == 0) {
      this.toastrService.error("Please provide valid Cost value");
      return false;
    }
    if (this.isValidString(this.blankOtherSection.processName)) {
      const newOtherSection: OtherCostModel = {
        processName: this.blankOtherSection.processName,
        estimatedCost: Number(this.convertInternationalToDecimal(this.blankOtherSection.estimatedCost)),
        description: '',
        isEditable: false
      };
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.otherCosts);
      this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.otherCostList.push(newOtherSection);
      this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.calculateTotal();
      this.blankOtherSection = this.initializeBlankOtherSection();
    }
    return true;
  }

  removeOtherCostItem(otherCostItem: OtherCostModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.otherCostList.indexOf(otherCostItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.otherCostList.splice(index, 1);
      this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.calculateTotal();
    }
  }

  multiplyMachineTimeAndCost(selectedItem: ManufacturingProcessModel) {
    selectedItem.totalMachiningCost = Number(selectedItem.totalMachineTimeInMinutes) * Number(selectedItem.machineCostPerMinute);
  }

  multiplyLaborTimeAndCost(selectedItem: ManufacturingProcessModel) {
    selectedItem.totalLaborCost = Number(selectedItem.totalLaborTimeInMinutes) * Number(selectedItem.laborCostPerMinute);
  }

  manufacturingTotalLaborTime() {
    return this.currentPart.quoteAssistData.quoteAssistModel?.manufacturingProcess?.manufacturingList.reduce((acc, item) => acc + this.convertInternationalToDecimal(item.totalLaborTimeInMinutes), 0);
  }

  manufacturingTotalMachineTime() {
    return this.currentPart.quoteAssistData.quoteAssistModel?.manufacturingProcess?.manufacturingList.reduce((acc, item) => acc + this.convertInternationalToDecimal(item.totalMachineTimeInMinutes), 0);
  }

  quotes: string[] = [
    "The only limit to our realization of tomorrow is our doubts of today.",
    "Do not wait to strike till the iron is hot, but make it hot by striking.",
    "Act as if what you do makes a difference. It does."
  ];

  currentQuote: string = this.quotes[0];

  generateRandomQuote(): void {
    const randomIndex = Math.floor(Math.random() * this.quotes.length);
    this.currentQuote = this.quotes[randomIndex];
  }

  additionalTotalCost(): number {
    return this.currentPart.quoteAssistData.quoteAssistModel?.additionalRequirements?.additionalRequirementList
      .filter(item => item.category === 'Primary')
      .reduce((total, item) => total + Number(item.estimatedCost || 0), 0);
  }

  otherTotalCost(): number {
    return this.currentPart.quoteAssistData.quoteAssistModel?.otherCosts?.otherCostList
      .reduce((total, item) => total + Number(item.estimatedCost || 0), 0);
  }
  overHeadRate(): number {
    const totalOverheadRate = this.currentPart.quoteAssistData.quoteAssistModel?.overhead?.overheadList
      .filter(item => item.category === 'Primary')
      .reduce((total, item) => total + Number(item.estimatedCost || 0), 0);
    const totalLaborMinutes = this.manufacturingTotalLaborTime();
    const totalMachineMinutes = this.manufacturingTotalMachineTime();
    return totalOverheadRate * (totalLaborMinutes + totalMachineMinutes);
  }
navigateToSummaryPage(){
  this.router.navigateByUrl(`summary?rfqId=${this.queryParams.rfqId}&rfqPartId=${this.currentPart.rfqPartId}&companyId=${this.rfqData.companyId}&contactId=${this.rfqData.supplierId}&isTrackingEnabled=${this.queryParams.isTrackingEnabled}&integration=${this.queryParams.integration}`);
}
  proceedToQuote() {
    this.currentPart.isAssistSkipped = false;
    this.currentPart.isAssistEnabled = true;
    this.addTracking(this.quoteAssistService, TrackingModule.QuoteAssist, TrackingEvents.ProceedSummary, this.currentPart, this.rfqData, 
      MixPanelEvents.ProceedSummary, this.queryParams);
    this.saveData(true).subscribe(id => {
     this.navigateToSummaryPage();
    });
  }

  skipQuoteAssist() {
    if (this.currentPart) {
      this.currentPart.isAssistSkipped = true;
      if(this.currentPart.isAssistEnabled){
        this.initializeSummary(this.currentPart);
        this.currentPart.isAssistEnabled = false;
      }else{
        if (this.tempSummaryPartQtyModel.length > 0) {
          this.currentPart.partQuantity = this.tempSummaryPartQtyModel;
        }
      }
      // this.pushTrackingDataToMFG("supplier quote assist skip to quote");
      this.addTracking(this.quoteAssistService, TrackingModule.QuoteAssist, TrackingEvents.SkipAssist, this.currentPart, this.rfqData, 
      MixPanelEvents.SkipAssist, this.queryParams);
      this.saveData(true).subscribe(id => {
        this.navigateToSummaryPage();
      });
    } else {
      this.toastrService.error("Something went wrong while fetching your data. Please close the assist and try again.");
    }
  }

  saveData(copySummary:boolean = false) {
    if (this.currentPart && copySummary && !this.currentPart.isAssistSkipped) {
      this.copySummaryDataToAllQuantities(this.currentPart);
    }
    return this.quoteAssistService.storeQuoteAssistData(this.rfqData);
  }

  copySummaryDataToAllQuantities(part: RfqPart): void {
    try {
      if (!part || Object.keys(part).length === 0) {
        console.error('The part object is empty, null, or undefined.');
        this.reinitializePart(part);
        return;
      }

      if (!part.partQuantity || part.partQuantity.length === 0) {
        console.warn('No quantities available to copy summary data.');
        return;
      }

      if (!this.currentPartQty || Object.keys(this.currentPartQty).length === 0) {
        console.error('The currentPartQty object is empty, null, or undefined.');
        this.reinitializeCurrentPartQty();
        return;
      }
      let sourceSummaryData = this.currentPartQty.summaryData;
      if (!sourceSummaryData || Object.keys(sourceSummaryData).length === 0) {
        this.initializeSummary(part);
        sourceSummaryData = this.currentPartQty.summaryData;
        return;
      }
      if(!this.currentPartQty.summaryData.isCopied){
        this.currentPartQty.summaryData.isCopied = true;
        sourceSummaryData.isCopied = true;
        part.partQuantity.forEach((quantity) => {
          quantity.summaryData = _.cloneDeep(sourceSummaryData);
        });
      }
    } catch (error) {
      console.error('Unexpected error while copying summary data:', error);
      this.toastrService.error('An unexpected error occurred while creating the summary for the quote.');
      throw error;
    }
  }

  private reinitializePart(part: RfqPart): void {
    console.log('Reinitializing the part object...');
  }

  private reinitializeCurrentPartQty(): void {
    console.log('Reinitializing the currentPartQty object...');
  }

  calculateTotal() {
    const { materials, machining, labor, additionalManufacturingRequirements, overhead } = this.currentPartQty.summaryData.pricePerUnit;
    const { tooling, miscellaneous, shippingHandling } = this.currentPartQty.summaryData;
    const { quoteAssistModel } = this.currentPart.quoteAssistData

    const qty = this.convertInternationalToDecimal(this.currentPartQty.qty);
    const materialsCost = quoteAssistModel.materials.canCalculate ? (this.convertInternationalToDecimal(materials.unitCost) * qty) : 0;
    const machiningCost = quoteAssistModel.machining.canCalculate ? (this.parseAndFormat(machining.machineList.reduce(
      (acc, item) => acc + this.convertInternationalToDecimal(item.costPerMin) * this.convertInternationalToDecimal(item.cyclePerUnit), 0
    )) * qty) : 0;
    const laborCost = quoteAssistModel.labor.canCalculate ? this.convertInternationalToDecimal(labor.totalCost) : 0;
    const amrCost = quoteAssistModel.additionalRequirements.canCalculate ? this.convertInternationalToDecimal(additionalManufacturingRequirements.totalCost) : 0;
    const overheadCost = quoteAssistModel.overhead.canCalculate ? this.convertInternationalToDecimal(overhead.totalCost) : 0;

    const toolingCost = quoteAssistModel.tooling.canCalculate?this.convertInternationalToDecimal(tooling.totalCost):0;
    const miscellaneousCost = quoteAssistModel.otherCosts.canCalculate?miscellaneous.itemList.reduce(
      (acc, otherCost) => {
        return acc + this.convertInternationalToDecimal(otherCost.estimatedCost)
      }, 0
    ):0;
    const shippingHandlingCost = quoteAssistModel.shipping.canCalculate?this.convertInternationalToDecimal(shippingHandling.cost):0;

    let pricePerUnit = this.parseAndFormat(
      this.parseAndFormat(materialsCost) +
      this.parseAndFormat(machiningCost) +
      laborCost +
      amrCost +
      overheadCost
    );
    
    let toolingCostTotal, miscellaneousCostTotal, shippingHandlingCostTotal, pricePerUnitTotal;

    toolingCostTotal = this.parseAndFormat((toolingCost * (1 + (this.convertInternationalToDecimal(tooling.profitMargin) / 100))))
    pricePerUnitTotal = this.parseAndFormat((((pricePerUnit / qty) * (1 + (this.convertInternationalToDecimal(this.currentPartQty.summaryData.pricePerUnit.profitMargin) / 100)))));
    miscellaneousCostTotal = this.parseAndFormat(this.parseAndFormat((miscellaneousCost) * (1 + (this.convertInternationalToDecimal(miscellaneous.profitMargin) / 100))));
    shippingHandlingCostTotal = this.parseAndFormat(this.parseAndFormat((shippingHandlingCost) * (1 + (this.convertInternationalToDecimal(shippingHandling.profitMargin) / 100))));
  

    // const totalCostProfit =
    //   this.parseAndFormat((toolingCostTotal + (this.parseAndFormat(pricePerUnitTotal) * qty) + miscellaneousCostTotal + shippingHandlingCostTotal).toFixed(2));
    const totalCostProfit = this.parseAndFormat((toolingCostTotal + (pricePerUnitTotal * qty) + miscellaneousCostTotal + shippingHandlingCostTotal));

    const totalCost = this.parseAndFormat(totalCostProfit/(1 + (this.convertInternationalToDecimal(this.profitMargin) / 100)));

    return {pricePerUnit: pricePerUnitTotal, totalCost: totalCost, totalCostProfit: totalCostProfit};
  }

  updateGrandTotal(): void {
    const costing = this.calculateTotal();
    let totalCost = this.parseAndFormat(costing.totalCost.toFixed(2));

    if (this.currentPart.quoteAssistData.quoteAssistModel.shipping.isSectionCompleted) {
        totalCost = costing.totalCostProfit
    }

    this.quoteGrandTotal = totalCost;
  }

  saveDraft() {
    // this.pushTrackingDataToMFG("supplier quote assist save to draft");
    this.addTracking(this.quoteAssistService, TrackingModule.QuoteAssist, TrackingEvents.SaveToDraft, this.currentPart, this.rfqData,
      "supplier quote assist save to draft", this.queryParams);
    this.showPageDataLoading = true;
    const payload = {
      CompanyId: this.rfqData!.companyId,
      SupplierId: this.rfqData!.supplierId,
      RfqId: this.rfqData!.rfqId,
      QuoteStatus: QuoteStatus.Draft,
      RfqPartsMetaData: JSON.stringify(this.rfqData)
    };

    this.quoteAssistService.saveDraft(payload).subscribe({
      next: (response: number) => {
        this.saveData().subscribe(id => {
          // console.log("Data saved for RFQ " + id);
        });
        this.showPageDataLoading = false;
        this.toastrService.success("Draft saved successfully.");
        // console.log('Draft saved successfully with ID:', response);
      },
      error: (error) => {
        console.error('Error saving draft:', error);
      }
    });
  }
  fetchDraft(): Observable<any> {
    return this.quoteAssistService.fetchDraft(this.rfqData!.companyId, this.rfqData!.rfqId);
  }
  openPartFileInNewTab() {
    if (window.parent) {
      window.parent.postMessage({ openPartFileInNewTab: true }, "*");
    }
  }
  pushTrackingDataToMFG(eventName: string, dataToSend: any = {}) {
    if (window.parent) {
      let dataToEmit: any = Object.assign({ isQuoteAssistTracking: true }, this.queryParams);
      dataToEmit = Object.assign(dataToEmit, dataToSend)
      dataToEmit["eventName"] = eventName;
      window.parent.postMessage(dataToEmit, "*");
    }
  }

  updateSupplierMetadata() {
    const transformedMetaData = {
      company_name: this.rfqData.supplierMetaData?.companyName || '',
      employee_size: this.rfqData.supplierMetaData?.employeeSize || '',
      my_capabilities: this.rfqData.supplierMetaData?.myCapabilities || [],
      my_equipment: this.rfqData.supplierMetaData?.myEquipment || [],
      industry_serving: this.rfqData.supplierMetaData?.industryServing || [],
      my_address: this.rfqData.supplierMetaData?.myAddress || '',
      zip_code: this.rfqData.supplierMetaData?.zipCode || '',
      process_rates: this.rfqData.supplierMetaData?.processRates || [],
      additional_info: this.rfqData.supplierMetaData?.additionalInfo || []
    };

    const payload = {
      CompanyId: parseInt(this.rfqData!.companyId.toString()),
      MetaData: JSON.stringify(transformedMetaData)
    };

    this.quoteAssistService.saveCompanyMetaData(payload).subscribe({
      next: (response: number) => {
        // console.log("Supplier Company Metadata updated");
      },
      error: (error) => {
        console.error('Error updating company metadata: ', error);
      }
    });
  }

  toggleTooltip(event: MouseEvent): void {
    const target = event.currentTarget as HTMLElement;
    const tooltip = target.parentElement?.querySelector('.tooltip-popup') as HTMLElement;
    
    // Close any other open tooltips first
    document.querySelectorAll('.tooltip-popup.show').forEach(element => {
      if (element !== tooltip) {
        element.classList.remove('show');
      }
    });
    
    // Toggle this tooltip
    if (tooltip.classList.contains('show')) {
      tooltip.classList.remove('show');
    } else {
      // Position the tooltip relative to the clicked element
      const rect = target.getBoundingClientRect();
      
      // Position above the icon
      tooltip.style.bottom = (window.innerHeight - rect.top + 10) + 'px';
      
      // Center horizontally, but ensure it stays within viewport
      let leftPos = rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2);
      
      // Adjust if tooltip would go off-screen
      if (leftPos < 20) {
        leftPos = 20; // Min 20px from left edge
      } else if (leftPos + tooltip.offsetWidth > window.innerWidth - 20) {
        leftPos = window.innerWidth - tooltip.offsetWidth - 20; // Min 20px from right edge
      }
      
      tooltip.style.left = leftPos + 'px';
      
      // Position the arrow
      const arrowLeft = rect.left + (rect.width / 2) - leftPos;
      tooltip.style.setProperty('--arrow-left', arrowLeft + 'px');
      
      // Show the tooltip
      tooltip.classList.add('show');
      
      // Adjust the z-index to be above all elements
      tooltip.style.zIndex = '9999';
    }
    
    // Close tooltip when clicking outside
    const closeTooltips = (e: MouseEvent) => {
      if (!target.contains(e.target as Node) && !tooltip.contains(e.target as Node)) {
        tooltip.classList.remove('show');
        document.removeEventListener('click', closeTooltips);
      }
    };
    
    // Add click handler with a small delay to prevent immediate closing
    setTimeout(() => {
      document.addEventListener('click', closeTooltips);
    }, 100);
    
    event.stopPropagation();
  }
}